import api from "@/lib/axiosConfig";
import { useMutation } from "@tanstack/react-query";

export type ArtmatchResult = {
  artworkId: string;
  s3_image_ref: string;
  similarity_score: number;
  title: string;
  year: string;
  author_name?: string;
  author_firstname?: string;
  publication_status: "published" | "draft";
  url: string;
  attachmentPublished: boolean;
};

const baseUrl = "back/api/artmatch";

const uploadArtmatchImage = async (image: File) => {
  const formData = new FormData();
  formData.append("image", image);

  const { data } = await api.post<ArtmatchResult[]>(baseUrl, formData);
  return data;
};

export const useArtmatchResults = () =>
  useMutation({
    mutationFn: uploadArtmatchImage,
    onError: () => {},
  });

const embedAttachment = async (attachmentId: string) => {
  const { data } = await api.post<{
    message: string;
  }>(`${baseUrl}/embed`, { attachmentId });
  return data;
};

export const useEmbedAttachment = () =>
  useMutation({
    mutationFn: embedAttachment,
  });
